module.exports = __webpack_public_path__ + "img/9788971844304.f83fbcb9.jpg";